import { useTranslation } from "react-i18next";
import ErrorIcon from "@mui/icons-material/Error";
import { useStyles } from "./NoPermissions.styles";
import { Typography } from "@mui/material";

const NoPermissions = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.mainWrapper}>
            <ErrorIcon className={classes.noDataIcon} />
            <Typography>{t("data.no_permissions")}</Typography>
        </div>
    );
};

export default NoPermissions;
